import React from 'react';
import AppFormInput from '../../../components/ui/AppFormInput';

// Password and confirm-password inputs used when setting a new password.
const NewPasswordFields = ({ password, onPasswordChange, confirmPassword, onConfirmPasswordChange, error }) => (
  <>
    <AppFormInput
      label="Password"
      type="password"
      placeholder="Password"
      value={password}
      onChange={(e) => onPasswordChange(e.target.value)}
      hint="At least 8 characters, with an uppercase letter, a number and a special character."
    />

    <AppFormInput
      label="Confirm password"
      type="password"
      placeholder="Confirm Password"
      value={confirmPassword}
      onChange={(e) => onConfirmPasswordChange(e.target.value)}
      error={error}
      required
    />
  </>
);

export default NewPasswordFields;
